module.exports = __webpack_public_path__ + "static/media/2023_40.4e93fa9b.jpg";